/* Packages */
import React from 'react';
import { render } from 'react-dom';

/* utilities */
import { parseDataToProps } from '~/utilities';

const productStickerNodes = Array.from(document.querySelectorAll('[data-sticker]'));
if (productStickerNodes.length) {
    import(/* webpackChunkName: "ProductSticker" */ './components/ProductSticker').then(({ default: ProductSticker }) => {
        productStickerNodes.forEach((node) => render(<ProductSticker {...parseDataToProps(node.dataset)}/>, node));
    });
}
